import React from 'react';
import { FadeIn } from './FadeIn';
import { Check } from 'lucide-react';
export function ProductIntro() {
  const features = ['The quick step that can reveal hidden charges on medical bills', 'The most common billing mistakes hospitals sometimes make', 'Why some medical bills are often negotiable', 'Simple questions you can ask billing departments', 'How to request itemized bills and review them properly', 'Ways families sometimes reduce balances through payment options'];
  return <section className="bg-brown-900 text-cream-50 py-12 md:py-20" data-id="element-156">
      <div className="max-w-3xl mx-auto px-4 md:px-6" data-id="element-157">
        <FadeIn data-id="element-158">
          <div className="text-center mb-8 md:mb-12" data-id="element-159">
            <h2 className="text-2xl md:text-5xl mb-4 text-cream-50" data-id="element-160">
              What You'll Discover Inside
            </h2>
            <p className="text-sm md:text-xl text-cream-200 font-light max-w-xs md:max-w-2xl mx-auto leading-relaxed" data-id="element-161">
              This guide gives you a simple blueprint to follow before paying a
              medical bill, so you don't have to feel unsure about what to do
              next.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-162">
          <div className="bg-brown-800/50 p-6 md:p-8 rounded-2xl border border-brown-600 mb-8 md:mb-12 backdrop-blur-sm" data-id="element-163">
            <p className="text-sm md:text-lg mb-6 md:mb-8 text-center text-cream-100" data-id="element-164">
              Inside you'll learn:
            </p>

            <div className="space-y-3 md:space-y-4 max-w-xs md:max-w-xl mx-auto" data-id="element-165">
              {features.map((feature, i) => <div key={i} className="flex items-start" data-id="element-166">
                  <div className="bg-terracotta-500 rounded-full p-1 mr-3 flex-shrink-0 mt-0.5" data-id="element-167">
                    <Check className="w-3 h-3 text-white" strokeWidth={3} data-id="element-168" />
                  </div>
                  <span className="text-sm md:text-lg font-medium leading-snug" data-id="element-169">
                    {feature}
                  </span>
                </div>)}
            </div>
          </div>

          <div className="text-center max-w-xs md:max-w-xl mx-auto" data-id="element-170">
            <p className="text-sm md:text-lg text-cream-200 leading-relaxed mb-2 md:mb-3" data-id="element-171">
              Most families never question medical bills simply because no one
              shows them where to start.
            </p>
            <p className="text-base md:text-2xl font-semibold text-terracotta-400" data-id="element-172">
              This guide gives you a clear starting point.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}